var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sticky-container"},_vm._l((_vm.socialList),function(social,i){return (social.url)?_c('span',{key:i},[(social.iconUrl)?_c('a',{attrs:{"href":social.url,"target":"_blank"}},[_c('img',{attrs:{"width":"32","height":"32","src":social.iconUrl}})]):_vm._e()]):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }